import { Formatter, useCMSDocument } from "@with-nx/hooks-n-helpers";
import { DesignedButton, Rule } from "@with-nx/simple-ui/atoms";
import { ReusableSection } from "@with-nx/simple-ui/atoms";
import {
  CatalogLayout,
  ReusablePreSlantedContainer,
} from "@with-nx/simple-ui/organisms";
import { Col, Row } from "antd";
import moment from "moment";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { FiDownloadCloud } from "react-icons/fi";
import { Box } from "simple-effing-primitive-layout";

import LegalMenuDesktop from "../../../components/w/LegalMenuDesktop";

const PDFViewer = dynamic(() => import("../../../components/w/PdfViewer"), {
  ssr: false,
});

export default function Page() {
  const router = useRouter();
  const { documents, loading } = useCMSDocument({});
  const document = documents.find(
    (doc) =>
      doc.slug?.toLowerCase() === (router?.query?.slug as string).toLowerCase()
  );

  if (loading) {
    return null;
  }

  if (!document) {
    return (
      <CatalogLayout footerNoAngle>
        <ReusableSection>
          <div className="container mx-auto max-w-7xl">
            <Rule rule="hs" color="var(--font1)" display="block" bottom={14}>
              Document {router?.query?.slug} not found.
            </Rule>
          </div>
        </ReusableSection>
      </CatalogLayout>
    );
  }

  return (
    <CatalogLayout
      footerNoAngle
      title={
        document?.name
          ? `${document?.name} | Broadway Media - Scenic Projections & Theatrical Resources`
          : undefined
      }
      description={`This ${
        document?.name
      } document was last updated on ${moment(document?.updatedAt).format(
        "MMMM DD, YYYY"
      )}`}
      resolvedUrl={router?.asPath}
    >
      <ReusablePreSlantedContainer>
        <ReusableSection>
          <div className="container mx-auto max-w-7xl">
            <Row gutter={[36, 18]} justify="space-between">
              <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                <LegalMenuDesktop />
              </Col>

              <Col xs={24} sm={24} md={24} lg={18} xl={18}>
                <Box parse="d:flex j:space-between a:flex-end">
                  <Box>
                    <Rule
                      rule="hs"
                      color="var(--font1)"
                      display="block"
                      bottom={14}
                    >
                      {document.name}
                    </Rule>

                    <Rule
                      rule="ls"
                      color="var(--font3)"
                      display="block"
                      bottom={24}
                    >
                      {`This ${
                        document.name
                      } document was last updated on ${moment(
                        document.updatedAt
                      ).format("MMMM DD, YYYY")}`}
                    </Rule>
                  </Box>

                  <DesignedButton
                    icon={<FiDownloadCloud title="download icon" />}
                    properties={{ bottom: 24 }}
                    label="Download"
                    href={Formatter.document(document?.file || "")}
                  />
                </Box>

                <PDFViewer url={Formatter.print(document.file || "")} />
              </Col>
            </Row>
          </div>
        </ReusableSection>
      </ReusablePreSlantedContainer>
    </CatalogLayout>
  );
}
